// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  SourceImportItem,
} from "./types";

export default {
  sourceId: __t.string(),
  get items() {
    return __t.array(SourceImportItem);
  },
  mode: __t.string(),
  folderId: __t.string(),
  spaceId: __t.string(),
  projectId: __t.string(),
};
